import React, { Component } from 'react';
import '../../css/App.css';
import appStore from '../../store/AppStore'
import { withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import Card from '@material-ui/core/Card';
import _ from 'lodash'
import resultStore from '../../store/ResultStore'
import { withRouter } from "react-router";
const queryString = require('query-string');

const styles = {   
    card:{
        marginTop: "15px",  
        padding: "15px"  
    },
    resultTable:{
        width: "100%",
        marginBottom: "30px",
        borderCollapse: "collapse"
    },
    resultTd:{
        lineHeight: 1.5,
        letterSpacing: "2px",
        width:"38%",        
        padding: "10px 0"
    },
    result:{
        width:"62%",
        color: "#777",
        textAlign: "center",
        fontWeight: 300
    },
    redText:{
        color: "red"
    }
}

class CardResultContent extends Component { 
  componentWillMount(){
    const parsed = queryString.parse(this.props.location.search);
    resultStore.getOrderData(parsed)
    
  }

  render() {
    const { classes } = this.props;

    return (
     <Card
        className={classes.card}
     >
        <table className={classes.resultTable}>
            <thead>               
            </thead>
            <tbody>
                {_.map(resultStore.resultData.gerneral, (item, key)=>{
                    return <tr key={key}>
                        <td className={`${classes.resultTd}`}>{item.title}</td>
                        <td className={`${classes.resultTd} ${classes.result}`}>{item.result}</td>
                    </tr>
                })}              
            </tbody>
        </table>
        <table className={classes.resultTable}>
            <thead>               
            </thead>
            <tbody>
                {_.map(resultStore.resultData.transition, (item, key)=>{
                    return <tr key={key}>
                            <td className={`${classes.resultTd}`}>{item.title}</td>
                            <td className={item.title=="授權結果"?`${classes.resultTd} ${classes.result} ${classes.redText}`:`${classes.resultTd} ${classes.result}`}>{item.result}</td>
                        </tr>             
                })}                 
            </tbody>
        </table>
     </Card>
    );
  }
}

export default withRouter(withStyles(styles)(observer(CardResultContent)));
